export default __webpack_public_path__ + "static/media/reddit_white.241ae80b.svg";